class Notification {
    id = null;
    name = '';
    subject = '';
    content = '';
    time = null;
    attachments = [];
    persons = [];
    active = true;
    sent = false;
    channel = 'email';
    report = null;
    recipient_scope = '';
    recipient_membership_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Notification;
